import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';

export class StartHoldForTurboLabelUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('UI.startHoldForTurboLabelTimer');
        this.onExecuted?.();
    }

    getName(): string {
        return 'StartHoldForTurboLabelUIAct';
    }
}